<template>
  <thux-table
    :instance="instance"
    :instance-name="instanceName"
    :order-by-dict="orderByDict"
    :goBack="goBack"
    :list="list"
    :fieldName="fieldName"
    :fields="fields"
    :fields-column="fieldsColumn"
    :select-all="selectAll"
    :selected-list="selectedList"
    :get-local-selected-all="getLocalSelectedAll"
    :local-selected-list="localSelectedList"
    @check-all="checkAll('code')"
    @check-none="checkNone('code')"
    @set-selected-row="setSelectedRow($event, 'code')"
    :show-checks="showChecks"
    :showDetailButton="showDetailButton"
    @change-status="changeInstanceStatus"
    @sort-changed="orderTable"
    @remove-order-by="removeOrderFromTable"
    @open-detail-form="$emit('open-detail-form', $event)"
  />
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { TYPES as DELIVERY_TYPES } from './store'
import { hasPerm } from '@/components/PermissionHelper'

import ThuxTableMixin from '../../../components/thux-table/ThuxTableMixin'
import ThuxTableChecksMixin from '../../../components/thux-table/thux-table-checks/ThuxTableChecksMixin'

export default {
  name: 'DeliveryTable',
  mixins: [ThuxTableMixin, ThuxTableChecksMixin],
  data () {
    return {
      fields: [
        {
          key: 'checks',
          label: this.$t('Checks')
        },
        {
          key: 'status',
          label: this.$t('Status'),
          tdClass: 'text-nowrap',
          thClass: 'text-nowrap',
          sortable: true,
          value: 'status'
        },
        {
          key: 'code',
          label: this.$t('Code'),
          type: 'text',
          thClass: 'text-nowrap',
          tdClass: 'text-nowrap',
          sortable: true,
          value: 'code'
        },
        {
          key: 'carriage__name',
          label: this.$t('Carriage'),
          tdClass: 'text-nowrap',
          thClass: 'text-nowrap',
          sortable: true,
          condition: 'carriage',
          value: 'name'
        },
        {
          key: 'transport_by',
          label: this.$t('Transport by'),
          type: 'text',
          thClass: 'text-nowrap',
          tdClass: 'text-nowrap',
          sortable: true,
          value: 'get_transport_by_display'
        },
        {
          key: 'action',
          label: this.$t('Actions'),
          tdClass: 'text-right text-nowrap',
          thClass: 'text-right text-nowrap'
        }
      ],
      fieldsColumn: ['status', 'code', 'transport_by', 'carriage__name'],
      fieldName: 'code'
    }
  },
  computed: {
    ...mapGetters({
      selectAll: DELIVERY_TYPES.GENERIC.carriage.delivery.LIST.GETTERS.selectAll,
      selectedList: DELIVERY_TYPES.GENERIC.carriage.delivery.LIST.GETTERS.selectedList
    }),
    showChecks () {
      return true
    },
    showDetailButton () {
      return hasPerm('carriage_delivery_retrieve')
    }
  },
  methods: {
    ...mapMutations({
      setList: DELIVERY_TYPES.GENERIC.carriage.delivery.LIST.MUTATIONS.setList,
      setSelectedList:
        DELIVERY_TYPES.GENERIC.carriage.delivery.LIST.MUTATIONS.setSelectedList,
      setSelectAll: DELIVERY_TYPES.GENERIC.carriage.delivery.LIST.MUTATIONS.setSelectAll
    }),
    ...mapActions({
      ...DELIVERY_TYPES.GENERIC.carriage.delivery.LIST.ACTIONS
    })
  }
}
</script>
